import React from 'react'
import { Route, useHistory } from 'react-router-dom'
import AppFrame from 'transfix-ui/components/AppFrame'
import { useIsEmbeddedInMobileApp } from 'apps/fleet-planner/hooks/useIsEmbeddedInMobileApp'
import { CancelStep } from './components/CancelStep'
import DeletionSuccessStep from './components/DeletionSuccessStep'
import { GoToMyDashboardStep } from './components/GoToMyDashboard'
import NotEligibleStep from './components/NotEligibleStep'
import VerifyAccountStep from './components/VerifyAccountStep/VerifyAccountStep'
import WelcomeStep from './components/WelcomeStep'

const AccountDeletionPage = () => {
  const history = useHistory()
  const mobileApp = useIsEmbeddedInMobileApp()

  const cancelHandler = () => {
    history.push('/account-deletion/step/cancel')
  }

  return (
    <AppFrame isMobileApp={mobileApp}>
      <Route path='/account-deletion/step/welcome'>
        <WelcomeStep onCancel={cancelHandler} />
      </Route>
      <Route path='/account-deletion/step/not-eligible'>
        <NotEligibleStep onCancel={cancelHandler} />
      </Route>
      <Route path='/account-deletion/step/verify-account'>
        <VerifyAccountStep onCancel={cancelHandler} />
      </Route>
      <Route path='/account-deletion/step/deletion-success'>
        <DeletionSuccessStep />
      </Route>
      <Route path='/account-deletion/step/cancel'>
        <CancelStep />
      </Route>
      <Route path='/account-deletion/step/go-to-dashboard'>
        <GoToMyDashboardStep />
      </Route>
    </AppFrame>
  )
}
export default AccountDeletionPage
